import React, {PropTypes as T} from 'react';
import fullScreenActions from '../../../actions/fullscreen';
import withDevice from '../../common/withDeviceHOC';
import translate from '../../../utils/translate';

export class ISMFullScreenButton extends React.Component {
  static propTypes = {
    isFullScreen: T.bool,
    isMobile: T.bool
  };

  toggleFullScreen = () => {
    fullScreenActions.toggle('ism');
  };

  render () {
    if (this.props.isMobile || this.props.isFullScreen) {
      return false;
    }

    let buttonClass = 'fullscreenbtn';
    let buttonText = translate('pageTranslations', 'FULL_SCREEN_MAP');
    const buttonTextClass = buttonClass + '__txt';

    return (
      <button
        className={buttonClass}
        onClick={this.toggleFullScreen}
        title={buttonText}
        data-component="full-screen-btn"
      >
        <span className={buttonTextClass}>{buttonText}</span>
      </button>
    );
  }
}

export default withDevice(ISMFullScreenButton);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/fullscreenbtn/index.js